import { makeServerRequest, makeServerPut } from './util';

const apiPrefix = "/api/v1/profile";

export const fetchProfile = () => {
    return (dispatch) => {
        dispatch({type: "FETCH_PROFILE"});

        return makeServerRequest(apiPrefix + "/").then(
            response => dispatch(fetchProfileSuccess(response.data))
        ).catch(
            error => dispatch(fetchProfileFailure(error))
        );
    };
};

export function fetchProfileSuccess(profile) {
    return {
        type: "FETCH_PROFILE_SUCCESS",
        payload: profile
    };
}

export function fetchProfileFailure(error) {
    return {
        type: "FETCH_PROFILE_FAILURE",
        payload: error
    };
}

export const updateProfile = (profile) => {
    return (dispatch) => {
        dispatch({type: "UPDATE_PROFILE"});

        return makeServerPut(apiPrefix + "/", profile).then(
            response => dispatch(updateProfileSuccess())
        ).catch(
            error => dispatch(updateProfileFailure(error))
        );
    };
};

export function updateProfileSuccess() {
    return {
        type: "UPDATE_PROFILE_SUCCESS",
    };
}

export function updateProfileFailure(error) {
    return {
        type: "UPDATE_PROFILE_FAILURE",
        payload: error
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/profile.js